import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { User } from "@/types/user.types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";

export const useGetUserQuery = (
  options?: Omit<
    UseQueryOptions<User, HTTPError, User, ["user"]>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      const res = await apiClient.get(ENDPOINTS.GET_USER).json<User>();
      return res;
    },
    ...options,
  });
};
